module.exports = __webpack_public_path__ + "assets/img/YCSC-1.437a9129.jpg";